{
    "NAME": "ConfigChangeLogListLanguage",
    "ConfigChangeLogList_Column_Description": "Beschrijving",
    "ConfigChangeLogList_Column_DateTime": "Datum\/Tijd",
    "ConfigChangeLogList_Column_User": "Gebruiker",
    "ConfigChangeLogList_Column_Action": "Actie",
    "ConfigChangeLogList_Column_Type": "Type",
    "ConfigChangeLogList_Column_CME": "CME",
    "ConfigChangeLogList_Column_TelSys": "Telefoonserver",
    "ConfigChangeLogList_Column_Partition": "Partitie",
    "ConfigChangeLogList_Filter_Before": "Voor",
    "ConfigChangeLogList_Filter_Actions": "Acties",
    "ConfigChangeLogList_Filter_EntityTypes": "Entiteitstypen",
    "ConfigChangeLogList_Filter_MultiSelectedCount": "[{} geselecteerd]",
    "ConfigChangeLogList_Filter_SearchUsername": "Gebruikersnaam zoeken",
    "ConfigChangeLogList_Filter_SuppressNulls": "Null-waarden onderdrukken",
    "ConfigChangeLogList_Filter_SuppressNulls_No": "Nee",
    "ConfigChangeLogList_Filter_SuppressNulls_Yes": "Ja",
    "ConfigChangeLogList_Filter_ActionDescription_All": "[Alle]",
    "ConfigChangeLogList_Filter_ActionDescription_INSERT": "Invoegen",
    "ConfigChangeLogList_Filter_ActionDescription_UPDATE": "Update",
    "ConfigChangeLogList_Filter_ActionDescription_DELETE": "Verwijderen",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN": "Login",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_FAILED": "Aanmelden mislukt",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_AS": "Inloggen als",
    "ConfigChangeLogList_Filter_ActionDescription_SYNC_REQUESTED": "Synchronisatie aangevraagd",
    "ConfigChangeLogList_Filter_TypeDescription_All": "[Alle]",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgents": "ACD-agenten",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgentsOwned": "ACD-agenten in eigendom (lidmaatschappen)",
    "ConfigChangeLogList_Filter_TypeDescription_Devices": "Apparaten",
    "ConfigChangeLogList_Filter_TypeDescription_DevicesOwned": "Aangeschafte apparaten (lidmaatschappen)",
    "ConfigChangeLogList_Filter_TypeDescription_DNISAssociations": "DNIS-verenigingen",
    "ConfigChangeLogList_Filter_TypeDescription_Codes": "Codes",
    "ConfigChangeLogList_Filter_TypeDescription_CallRecordingIntegrations": "Integraties voor gespreksopname",
    "ConfigChangeLogList_Filter_TypeDescription_Partitions": "Partities",
    "ConfigChangeLogList_Filter_TypeDescription_TelephoneSystems": "Telefoonsystemen",
    "ConfigChangeLogList_Filter_TypeDescription_Users": "Gebruikers",
    "ConfigChangeLogList_Filter_TypeDescription_CRMConfiguration": "CRM-configuratie",
    "ConfigChangeLogList_Detail_Title": "Auditlogboekvermelding",
    "ConfigChangeLogList_Detail_SummaryColumnItem": "Item",
    "ConfigChangeLogList_Detail_SummaryColumnValue": "Waarde",
    "ConfigChangeLogList_Detail_Field": "Veld",
    "ConfigChangeLogList_Detail_OldValue": "Oude waarde",
    "ConfigChangeLogList_Detail_NewValue": "Nieuwe waarde"
}